import { render, staticRenderFns } from "./IndexStar.vue?vue&type=template&id=38e3718f&scoped=true&"
import script from "./IndexStar.vue?vue&type=script&lang=js&"
export * from "./IndexStar.vue?vue&type=script&lang=js&"
import style0 from "./IndexStar.vue?vue&type=style&index=0&id=38e3718f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e3718f",
  null
  
)

export default component.exports